export const PAYMENT_ERROR_ITEMS = [
  {
    titleKey: 'general.insufficient_balance',
    descriptionKey: 'payment.error.card_insufficient_funds'
  },
  {
    titleKey: 'general.process_declined',
    descriptionKey: 'payment.error.user_confirmation'
  },
  {
    titleKey: 'general.invalid_card_number',
    descriptionKey: 'payment.error.invalid_card_number'
  },
  {
    titleKey: 'general.invalid_expiry_date',
    descriptionKey: 'payment.error.invalid_expiry_date'
  },
  {
    titleKey: 'general.invalid_security_code',
    descriptionKey: 'payment.error.cvv_incorrect'
  },
  {
    titleKey: 'general.bank_declined',
    descriptionKey: 'payment.declined_by_bank'
  },
  {
    titleKey: 'general.3d_secure_not_supported',
    descriptionKey: 'payment.error.3d_secure_not_supported'
  },
  {
    titleKey: 'general.operation_timed_out',
    descriptionKey: 'payment.error.transaction_timeout'
  },
  {
    titleKey: 'general.card_blocked',
    descriptionKey: 'payment.error.card_not_enabled_for_online'
  },
  {
    titleKey: 'general.transaction_not_allowed',
    descriptionKey: 'payment.error.pre_auth_card_type_mismatch'
  },
  {
    titleKey: 'general.limit_reached',
    descriptionKey: 'payment.error.daily_monthly_limit_exceeded'
  }
]; 